const eventReady = (obj) => {
  try {
    window.digitalData = window.digitalData || {};
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(obj);
  } catch (error) {
    console.error('GlobalDDO event push failed', error); // eslint-disable-line
  }
};

export const postEvent = (primaryCategory, eventName, eventSettings) => {
  try {
    let eventData = {};
    eventData.category = {};
    eventData.category.primaryCategory = primaryCategory;
    eventData.eventInfo = {};
    eventData.eventInfo.eventName = eventName;
    if (eventSettings) {
      eventData.myAccount = {};
      eventData.myAccount.settings = eventSettings;
    }
    eventReady(eventData);
  } catch (error) {
    console.error( // eslint-disable-line
      'Error during analytics postEvent',
      primaryCategory,
      eventName
    );
  }
};

export const setPageData = (pageName, pageType) => {
  window.digitalData = window.digitalData || {};
  window.digitalData.page = window.digitalData.page || {};
  window.digitalData.page.pageInfo = window.digitalData.page.pageInfo || {};
  const pageView = pageName ? '>' + pageName : '';
  window.digitalData.page.pageInfo.pageName = 'my account>my home depot credit card' + pageView;
  window.digitalData.page.pageInfo.pageType = pageType || 'maml:plcc';

  window.digitalData.page.category = window.digitalData.page.category || {};
  window.digitalData.page.category.primaryCategory = window.digitalData.page.category.primaryCategory || 'my account';
  window.digitalData.page.category.subCategory1 = 'my account>my home depot credit card';
  window.digitalData.page.category.subCategory2 = 'my account>my home depot credit card' + pageView;
};
